// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".note-box{padding:1.2rem 1.4rem;font-size:1rem;line-height:1.45em}.note-box--gray{background:#f5f7fa;font-style:italic}.note-box--blue{background:#f5f7fa;color:#51596c}", ""]);
// Exports
module.exports = exports;
